"use client";
// import React, { Suspense, useState } from "react";
import React, { Suspense } from "react";
import PropTypes from "prop-types";
import DataTable from "react-data-table-component";

// import Button from "@/components/Button";
// import SvgIcon from "@/lib/icons/SvgIcon";
// import { useEditLeadNoteMutation } from "@/lib/redux/api/leadsApi";

const ClassTable = ({
  data,
  columns,
  refetch = null,
  expandableRowsComponent = null,
  onRowExpandToggled = null,
  expandableRowExpanded = null,
  pagination = null,
  paginationPerPage = null,
  paginationRowsPerPageOptions = null,
}) => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div>
        <DataTable
          columns={columns}
          data={data}
          expandableRows={!!expandableRowsComponent}
          expandableRowsComponent={expandableRowsComponent}
          expandOnRowClicked={false}
          expandableRowExpanded={expandableRowExpanded}
          onRowExpandToggled={onRowExpandToggled}
          noExpandOnRowClick={true}     
          pagination={pagination !== null && pagination !== undefined ? pagination : (data && data?.length > 10)}               
          paginationPerPage={paginationPerPage || 25}
          paginationRowsPerPageOptions={paginationRowsPerPageOptions || [10, 25, 50]}
          customStyles={{
          cells: {
            style: {
              paddingLeft: "16px",
            },
          },
          expanderCell: {
            style: {
              width: "0",
              padding: "0",
              margin: "0",
              display: "none",
            },
          },
          headRow: {
            style: {
              minHeight: "52px",
            },
          },
        }}
        />
      </div>
    </Suspense>
  );
};

ClassTable.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  refetch: PropTypes.func,
  expandableRowsComponent: PropTypes.elementType,
  onRowExpandToggled: PropTypes.func,
  expandableRowExpanded: PropTypes.func,
  pagination: PropTypes.bool,
  paginationPerPage: PropTypes.number,
  paginationRowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
};

export default ClassTable;
